<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <form @submit.prevent="definePassword">
          <b-loading
            :is-full-page="true"
            :active="isLoading"
            :can-cancel="false"
          ></b-loading>

          <div class="columns">
            <div class="column"></div>
            <div class="column is-half has-text-centered">
              <figure
                class="image"
                style="max-width: 170px; margin: auto; margin-bottom: 1rem;"
                v-if="$chain === 'mq'"
              >
                <logo-mq />
              </figure>

              <figure
                class="image"
                style="max-width: 170px; margin: auto; margin-bottom: 1rem;"
                v-else-if="$chain === 'brmania'"
              >
                <logo-brmania />
              </figure>

              <figure
                class="image"
                style="max-width: 170px; margin: auto; margin-bottom: 1rem;"
                v-else
              >
                <logo-smart-orange-outline />
              </figure>

              <h1 class="title is-size-3 has-text-weight-semibold">
                {{ $t("definePassword.createPassword") }}
              </h1>

              <h2 class="subtitle">
                {{ $t("definePassword.passwordRequirements") }}
              </h2>

              <b-field>
                <b-input
                  size="is-medium"
                  v-model="password"
                  class="is-expanded"
                  type="password"
                  :placeholder="$t('common.password')"
                  password-reveal
                ></b-input>
              </b-field>

              <b-field>
                <b-input
                  size="is-medium"
                  v-model="passwordConfirmation"
                  class="is-expanded"
                  type="password"
                  :placeholder="$t('common.passwordConfirmation')"
                  password-reveal
                ></b-input>
              </b-field>

              <button
                class="button is-medium is-fullwidth has-text-weight-bold"
                :style="{
                  backgroundColor: $primaryColor,
                  color: $primaryColorContrast
                }"
              >
                {{ $t("definePassword.definePassword") }}
              </button>
            </div>
            <div class="column"></div>
          </div>
        </form>
      </div>
    </div>

    <div class="hero-footer">
      <flag-icons />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common.js";
import flagIcons from "./common/FlagIcons";
import logoSmartOrangeOutline from "./common/logo-onii-smart-orange-outline-tagline";
import logoMq from "./common/logo-mq";
import logoBrmania from "./common/logo-brmania";

export default {
  mixins: [common],

  components: {
    flagIcons,
    logoSmartOrangeOutline,
    logoMq,
    logoBrmania
  },

  data() {
    return {
      isLoading: false,
      emailValidationToken: "",
      password: "",
      passwordConfirmation: ""
    };
  },

  methods: {
    definePassword() {
      this.isLoading = true;
      this.$store
        .dispatch("definePassword", {
          emailValidationToken: this.emailValidationToken,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: this.$t("common.success"),
              message: this.$t("definePassword.nextStepLogin"),
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$router.push("/"),
              onCancel: () => this.$router.push("/")
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["locale"])
  },

  mounted() {
    this.$store.dispatch("setLocale", this.locale);
    this.emailValidationToken = this.$route.query.emailValidationToken;
  }
};
</script>

<style>
form {
  width: 80%;
  margin: auto;
}
</style>
